import {
  type CurrentAccount,
  useCurrentAccountEntitlements,
} from '../CurrentAccountEntitlementsContext';

/**
 * A hook to get the tools for a product in the current account. Should be used for custom side navigation implementations.
 * @param productId - the id of the product to get the tools for in the current account
 * @returns the tools for the product
 */
export function useAccountProductTools({
  productId,
}: {
  productId?: string;
}): CurrentAccount['products'][number]['tools'] {
  const { currentAccount } = useCurrentAccountEntitlements();

  if (!productId) {
    return [];
  }

  const currentProduct = currentAccount?.products.find(
    (product) => product.key === productId,
  );

  return (
    currentProduct?.tools.filter((tool) => tool.authorized !== false) || []
  );
}
